module.exports = __webpack_public_path__ + "img/frame (175).132a8222.jpg";